import React, { useEffect, useState } from "react";
import Layout from "../pages/Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddProductModal from "./AddProduct";
import HomeIcon from "../assets/icons/home_icon";
import axios from "axios"
import config from "../config";
import EditIcon from "../images/edit_icon";
import DeleteIcon from "../images/delete_icon";
import CheckIcon from "../assets/icons/check_icon";
import { v4 as uuidv4 } from 'uuid'; // Import UUID
import { jsPDF } from "jspdf"; // Import jsPDF
import html2canvas from "html2canvas";
import { ToastContainer, toast } from 'react-toastify';
import { setCharacterSpacing } from "pdf-lib";
import CustomerDetailPdf from "./Customer_pdf";
import ClipLoader from "react-spinners/ClipLoader";
import ReactDOM from 'react-dom';
import { confirmAlert } from "../utils/swal";




import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format

registerLocale("en-GB", enGB);


const NewQuote = () => {
  const [quoteNo, setQuoteNo] = useState("");

  const [product, setProduct] = useState("");
  const [isQuoteCreated, setIsQuoteCreated] = useState(false);
  const [netPrice, setNetPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [deliveryDate, setDeliveryDate] = useState(() => {
    const today = new Date();
    const oneMonthLater = new Date(today.setMonth(today.getMonth() + 1));
    return oneMonthLater.toISOString().split("T")[0];
  });

  const [isEmailLoading, setIsEmailLoading] = useState(false);


  const [weddingDate, setWeddingDate] = useState("");
  const [discount, setDiscount] = useState(0);
  const [quoteDate, setQuoteDate] = useState(new Date().toISOString().split("T")[0]);
  const [comments, setComments] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const { customer_id } = useParams();
  const [status, setStatus] = useState("Pending");
  const [isAccepted, setIsAccepted] = useState(false);
  const [quoteId, setQuoteId] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [customer, setCustomer] = useState("");
  // console.log("customer", customer)

  const [newProduct, setNewProduct] = useState({
    style: "",
    quantity: 1,
    fabric: "",
    lining: "",
    groomsman: false,
    price: 0,
    remarks: "",
    quote_id: quoteId ? quoteId : null,
  });


  const handleQuoteCreated = (newQuoteId) => {

    setQuoteId(newQuoteId);
  };

  // console.log(newProduct)

  const generateRandomQuoteNo = () => {
    const randomNumber = Math.floor(Math.random() * 100000) + 1000;
    return `AR${randomNumber}`;
  };

  const checkQuoteNoExistence = async (generatedQuoteNo) => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/v1/checkQuoteNo`, {
        params: { quoteNo: generatedQuoteNo }
      });
      return response.data.exists;
    } catch (error) {
      console.error("Error checking quote number existence:", error);
      return false;
    }
  };

  const generateUniqueQuoteNo = async () => {
    let isUnique = false;
    let newQuoteNo = "";

    while (!isUnique) {
      newQuoteNo = generateRandomQuoteNo();
      isUnique = !(await checkQuoteNoExistence(newQuoteNo));
    }

    setQuoteNo(newQuoteNo);
  };

  useEffect(() => {
    generateUniqueQuoteNo();
  }, []);


  // useEffect(() => {
  //   if (netPrice && totalPrice) {
  //     const calculatedDiscount = parseFloat(netPrice) - parseFloat(totalPrice);
  //     setDiscount(calculatedDiscount.toFixed(2)); // rounded to 2 decimals
  //   }
  // }, [netPrice, totalPrice]);

  useEffect(() => {
    const np = Number(netPrice) || 0;
    let d = Number(discount) || 0;

    // clamp discount between 0 and netPrice
    if (d < 0) d = 0;
    if (d > np) d = np;

    const newTotal = Math.max(0, np - d);
    setTotalPrice(Number(newTotal.toFixed(2)));
  }, [netPrice, discount]);

  const handleSubmit = async () => {
    const quoteData = {
      customer_id,
      quoteNo,
      // products,
      netPrice: parseFloat(netPrice),
      totalPrice: parseFloat(totalPrice),
      discount,
      deliveryDate,
      weddingDate,
      quoteDate: new Date().toISOString().split("T")[0],
      comments,
      status: status,
    };

    try {
      // console.log('quoteData', quoteData)
      const response = await axios.post(`${config.BASE_URL}/api/v1/addQuote`, quoteData);
      if (response.status === 201) {
        const quote_new_Id = response.data.quote._id;

        // alert(response.data.message);
        toast(response.data.message)
        setQuoteNo("");
        setProducts([]);
        setNetPrice("");
        setTotalPrice("");
        setDeliveryDate("");
        setWeddingDate("");
        setComments("");
        setQuoteId("")
        generateUniqueQuoteNo()
        navigate(`/edit-quote/${quote_new_Id}`);
      } else {
        // alert("Failed to create quote. Please try again.");
        toast.error("Failed to create quote. Please try again.");
      }
    } catch (error) {
      console.error("Error creating quote:", error);
      toast.error("An error occurred while creating the quote.");
    }
  };

  const handlePendingAcceptance = () => {
    setStatus("Accepted");
    setIsAccepted(true);

  };



  const handleDeleteProduct = async (productId) => {

   const confirmDelete = await confirmAlert({
  title: "Delete Product?",
  text: "Are you sure you want to delete this product? This action cannot be undone.",
  confirmText: "Yes, delete it",
  cancelText: "Cancel",
});
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteProduct/${productId}`
      );

      if (response.status === 200) {
        toast.success("Product deleted successfully.");

        setProducts((prevProducts) =>
          prevProducts.filter((product) => product._id !== productId)
        );

        // Recalculate total price after deletion
        const updatedProducts = products.filter((product) => product._id !== productId);
        const newTotalPrice = updatedProducts.reduce((sum, item) => {
          const quantity = Number(item.quantity) || 1;
          const price = Number(item.price) || 0;
          return sum + quantity * price;
        }, 0);

        setNetPrice(newTotalPrice);
        setTotalPrice(newTotalPrice);
      }
      else {
        toast.error("Failed to delete the product. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("An error occurred while deleting the product.");
    }
  };



  const productOptions = [
    { id: 1, style: "Suit" },
    { id: 2, style: "Jacket" },
    { id: 3, style: "Shirt" },
    { id: 4, style: "Pant" },
    { id: 5, style: "Tuxedo" },
    { id: 6, style: "Vest" },
    { id: 7, style: "Overcoat" },
    { id: 8, style: "Accessories" },
  ];

  // console.log(newProduct);
  const ALLOWED_SUIT_COMPONENTS = ["Jacket", "Pant"]; // tweak if you want Vest/Tuxedo etc.

  const fetchAdditionalProductsForSuit = async (quoteNo) => {
    try {
      const response = await axios.post(`${config.BASE_URL}/api/v1/suitParts`, {
        quoteNo,
      });

      // server might return additionalParts or allProducts; normalize
      const additionalParts = response?.data?.additionalParts || response?.data?.parts || [];

      // filter only allowed components (defensive)
      const filtered = Array.isArray(additionalParts)
        ? additionalParts.filter((p) => {
          const desc = (p.description || p.style || "").toString().trim();
          return ALLOWED_SUIT_COMPONENTS.includes(desc);
        })
        : [];

      return filtered;
    } catch (error) {
      console.error("Error fetching suit parts:", error);
      return [];
    }
  };




  const handleSaveProductdata = async (pro) => {
    setLoading(true);
    console.log("runnnnnnng")

    try {
      // make a shallow copy and normalize description for checks
      const newProducts = [...products];
      const desc = (pro.description || "").toString().trim();
      const isSuit = desc.toLowerCase() === "suit";

      // check if product exists already
      const existingIndex = newProducts.findIndex((p) => p._id === pro._id);

      if (existingIndex !== -1) {
        // Update existing product
        newProducts[existingIndex] = pro;
      } else {
        // Add the product itself first
        newProducts.push(pro);
      }

      // Only fetch additional parts if this is a Suit and these parts were not already added
      if (isSuit) {
        // Prevent duplicate additions: check if any item already has parentSuitId === pro._id
        const alreadyHasComponents = newProducts.some((p) => p.parentSuitId === pro._id);

        if (!alreadyHasComponents) {
          const additionalParts = await fetchAdditionalProductsForSuit(quoteNo);

          // Map the returned parts to include a deterministic temporary id and parentSuitId
          const mappedParts = (Array.isArray(additionalParts) ? additionalParts : []).map((p) => ({
            ...p,
            _id: p._id || uuidv4(), // if server didn't supply a stable _id, create one
            quote_id: quoteId || null,
            parentSuitId: pro._id || (pro._id ? pro._id : uuidv4()), // associate with parent suit
          }));

          // Append only those that are not already present (by description + parentSuitId)
          mappedParts.forEach((mp) => {
            const dup = newProducts.find(
              (existing) =>
                (existing.parentSuitId && existing.parentSuitId === mp.parentSuitId) &&
                (existing.description === mp.description)
            );
            if (!dup) newProducts.push(mp);
          });
        }
      }

      // Update main state in a single set to avoid extra renders
      setProducts(newProducts);

      // Recalculate totals
      const total = newProducts.reduce((sum, item) => {
        const quantity = Number(item.quantity) || 1;
        const price = Number(item.price) || 0;
        return sum + quantity * price;
      }, 0);

      setNetPrice(total);
      setTotalPrice(total);

      handleModalClose();
    } catch (err) {
      console.error("handleSaveProduct error:", err);
      toast.error("Failed to save product.");
    } finally {
      setTimeout(() => setLoading(false), 300); // keep small delay for UX
    }
  };

  


  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewProduct({
      name: "",
      quantity: 1,
      fabric: "",
      lining: "",
      groomsman: false,
      price: 0,
      remarks: "",
    });
    fetchCustomerAllDetails();
  };


  // console.log('products', products)


  const fetchCustomerAllDetails = async () => {
    // setLoading(true);
    try {
      const response = await fetch(`${config.BASE_URL}/api/v1/customerDetails/${customer_id}`);

      if (!response.ok) {
        throw new Error('Failed to fetch customer details');
      }
      const data = await response.json();
      setCustomer(data);
    } catch (err) {
      // setError(err.message);
    }
  };

  useEffect(() => {
    fetchCustomerAllDetails();
  }, [customer_id]);


  const handleAddProductClick = () => {
    setIsModalOpen(true);
  };

  const navigate = useNavigate();
  const handleCreateOrder = () => {
    // navigate(`/add-order/${customer_id}?total_price=${totalPrice}`);
     toast.warning("Please Save quote first.");
        return;
    // navigate(`/add-order/${customer_id}?total_price=${totalPrice}`, {
    //   state: {
    //     quote_id: quoteId,
    //     total_price: totalPrice,
    //     quoteNo: quoteNo,
    //     deliveryDate: deliveryDate,
    //     weddingDate: weddingDate
    //   },
    // });

  };


  const handleEditProduct = async (product) => {
    setNewProduct(product);
    setIsModalOpen(true);
  };



  const handleEmail = async (customer) => {
  setIsEmailLoading(true);

  try {
    // 👉 1. Temp container
    const container = document.createElement("div");
    document.body.appendChild(container);

    // 👉 2. Prepare items
    const items = products.map((product) => ({
      description: `${product.description} - ${
        product?.groomsman == "true" ? "Groomsman " : ""
      }${product.fabric} ${product.lining}`,
      quantity: Number(product.quantity) || 1,
      price: Number(product.price) || 0,
      amount:
        (Number(product.quantity) || 1) *
        (Number(product.price) || 0),
    }));

    const totalAmount = items.reduce((sum, item) => sum + item.amount, 0);

    // 👉 3. Prepare data
    const updatedCustomer = {
      ...customer,
      date: quoteDate,
      quoteNumber: quoteNo,
      items,
      netPrice,
      totalAmount: totalPrice,
      discount,
      comments,
      
    };

    // 👉 4. Render component
    ReactDOM.render(<CustomerDetailPdf customer={updatedCustomer} />, container);

    // 👉 wait for render
    await new Promise((resolve) => setTimeout(resolve, 500));

    const element = container.querySelector(".customer_pdf");

    // 👉 5. Canvas
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("portrait", "mm", "a4");

    const pageWidth = 210;
    const pageHeight = 297;

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let finalWidth = imgWidth;
    let finalHeight = imgHeight;

    // 👉 AUTO SCALE (MAIN LOGIC 🔥)
    if (imgHeight > pageHeight) {
      const scale = pageHeight / imgHeight;
      finalWidth = imgWidth * scale;
      finalHeight = imgHeight * scale;
    }

    // 👉 center content
    const xOffset = (pageWidth - finalWidth) / 2;
    const yOffset = (pageHeight - finalHeight) / 2;

    pdf.addImage(imgData, "JPEG", xOffset, yOffset, finalWidth, finalHeight);

    // 👉 convert to blob (EMAIL)
    const pdfBlob = pdf.output("blob");

    // 👉 cleanup
    document.body.removeChild(container);

    // 👉 filename
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;

    const clientName = (customer.customer_name || "Customer").replace(/\s+/g, "_");
    const fileName = `Quote_${clientName}_${formattedDate}.pdf`;

    // 👉 send API
    const formData = new FormData();
    formData.append("name", customer.customer_name);
    formData.append("email", customer.email);
    formData.append("subject", quoteId);
    formData.append("title", fileName);
    formData.append("pdf", pdfBlob, fileName);
    formData.append("type", "quote");

    const response = await axios.post(
      `${config.BASE_URL}/api/v1/sendEmail`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      toast.success("Email sent successfully!");
    } else {
      toast.error("Failed to send email.");
    }

  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Error sending email.");
  } finally {
    setIsEmailLoading(false);
  }
};

  const handleGeneratePdf = async (customer) => {
  try {
    // 👉 1. Temp container
    const container = document.createElement("div");
    document.body.appendChild(container);

    // 👉 2. Prepare items
    const items = products.map((product) => ({
      description: `${product.description} - ${
        product?.groomsman == "true" ? "Groomsman " : ""
      }${product.fabric} ${product.lining}`,
      quantity: Number(product.quantity) || 1,
      price: Number(product.price) || 0,
      amount:
        (Number(product.quantity) || 1) *
        (Number(product.price) || 0),
    }));

    // 👉 3. Prepare data
    const updatedCustomer = {
      ...customer,
      date: quoteDate,
      quoteNumber: quoteNo,
      items,
      netPrice,
      totalAmount: totalPrice,
      discount,
      comments,
    };

    // 👉 4. Render component
    const root = ReactDOM.createRoot(container);
    root.render(<CustomerDetailPdf customer={updatedCustomer} />);

    // 👉 Wait for render
    await new Promise((resolve) => setTimeout(resolve, 500));

    const element = container.querySelector(".customer_pdf");

    // 👉 5. Canvas
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("portrait", "mm", "a4");

    const pageWidth = 210; // A4 width mm
    const pageHeight = 297; // A4 height mm

    // 👉 original image size
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let finalWidth = imgWidth;
    let finalHeight = imgHeight;

    // 👉 6. SCALE DOWN if overflow
    if (imgHeight > pageHeight) {
      const scale = pageHeight / imgHeight;
      finalWidth = imgWidth * scale;
      finalHeight = imgHeight * scale;
    }

    // 👉 center content
    const xOffset = (pageWidth - finalWidth) / 2;
    const yOffset = (pageHeight - finalHeight) / 2;

    pdf.addImage(imgData, "JPEG", xOffset, yOffset, finalWidth, finalHeight);

    // 👉 filename
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;

    const clientName = (customer.customer_name || "Customer").replace(/\s+/g, "_");

    pdf.save(`Quote_${clientName}_${formattedDate}.pdf`);

    // 👉 cleanup
    root.unmount();
    document.body.removeChild(container);

  } catch (error) {
    console.error("Single page PDF error:", error);
  }
};

  const toLocalISOString = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


   useEffect(() => {
    if (isModalOpen ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);
  


  return (
    <>
      <Layout>



        <div className="new-quote-page">
          {/* Header */}
          <header className="header">
            <h1>NEW QUOTE</h1>
            <p>
              <HomeIcon /> / Customers / New Quote
            </p>
          </header>
          <h2 className="quote_customer_title">
            Customer <span className="quote_customer_name">{customer.customer_name}</span>
          </h2>
          <div className="page_card_body">
            <form className="quote-form">
              <div className="quote_form_header">
                <div className="quote_number">
                  <label>Quote No</label>
                  <input
                    type="text"
                    value={quoteNo}
                    onChange={(e) => setQuoteNo(e.target.value)}
                    placeholder="Quote No"
                  />
                </div>
                <div className="quote_date">
                  <input
                    type="date"
                    value={quoteDate}
                    onChange={(e) => setQuoteDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="select_product_and_date">
                <div className="select_product">
                  <label>Select Product</label>
                  <button
                    type="button"
                    onClick={handleAddProductClick}
                    className="add-product-btn"
                  >
                    {" "}
                    Add Product{" "}
                  </button>
                  {/* <div className="saved-products">
                  {products.length === 0 ? (
                    <p></p>
                  ) : (
                    <table className="product-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Quantity</th>
                          <th>Fabric</th>
                          <th>Lining</th>
                          <th>Groomsman</th>
                          <th>Price</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((product, index) => (
                          <tr key={index}>
                            <td>{product.name}</td>
                            <td>{product.quantity}</td>
                            <td>{product.fabric}</td>
                            <td>{product.lining}</td>
                            <td>{product.groomsman ? "Yes" : "No"}</td>
                            <td>${product.price}</td>
                            <td>{product.remarks}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div> */}
                </div>
                <div className="select_date">
                  <div className="form-group">
                    <label>Delivery Date</label>
                    <ReactDatePicker
                      className="date-picker"
                      selected={deliveryDate ? new Date(deliveryDate) : null}
                      onChange={(date) => {
                        if (date) {
                          setDeliveryDate(toLocalISOString(date));
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="en-GB"
                      placeholderText="Select delivery date"
                    />
                  </div>

                  <div className="form-group">
                    <label>Wedding Date</label>
                    <ReactDatePicker
                      className="date-picker"
                      selected={weddingDate ? new Date(weddingDate) : null}
                      onChange={(date) => {
                        if (date) {
                          // --- FIX APPLIED HERE ---
                          setWeddingDate(toLocalISOString(date));
                          // -------------------------
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="en-GB"
                      placeholderText="Select wedding date"
                    />
                  </div>
                </div>

              </div>


              {products.map((product, index) => (
                <div className="edit_quote_product">
                  <div className="edit_quote_header">
                    <div className="input_product">
                      <input
                        type="text"
                        name=""
                        id="product_name"
                        value={product.description}
                      />
                    </div>
                    <div className="edit_delete_btns">
                      <button
                        className="edit_details"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditProduct(product);
                        }}
                      >
                        <EditIcon />
                      </button>
                      <button
                        className="remove_product"
                        onClick={(e) => {
                          e.preventDefault();
                          handleDeleteProduct(product._id);
                        }}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </div>
                  <div className="edit_quote_product_detils">
                    <div className="left">
                      <div class="form-group row">
                        <label class="field_label">Quantity</label>
                        <div class="field_value">
                          <input type="number" value={product.quantity} />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="field_label">Fabric</label>
                        <div class="field_value">
                          <input type="text" value={product.fabric} />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="field_label">Lining</label>
                        <div class="field_value">
                          <input type="text" value={product.lining} />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="field_label">Groomsman</label>
                        <div className="input_field">
                          <input
                            type="checkbox"
                            checked={product.groomsman === "true" || false}
                          />
                          <span className="checked_icon">
                            <CheckIcon />
                          </span>
                          <p>Yes</p>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <div class="form-group row">
                        <label class="field_label">Price</label>
                        <div class="field_value">
                          <input type="number" value={product.price} />
                        </div>
                      </div>
                      <div class="form-group textarea">
                        <label class="field_label">Remarks</label>
                        <div class="field_value">
                          <textarea
                            type="text"
                            value={product.remarks}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}


              <div className="quote_pricing">
                <h4>Price</h4>
                <div className="quote_pricing_fields">
                  <div className="form-group">
                    <label>Net Price $</label>
                    <input
                      type="number"
                      value={netPrice}
                      // onChange={(e) => setNetPrice(e.target.value)}
                      placeholder="Net Price"
                    />
                  </div>

                  <div className="form-group total-price">
                    <label>Total $</label>
                    <input
                      type="number"
                      value={totalPrice}
                      // onChange={(e) => setTotalPrice(e.target.value)}
                      placeholder="Total Price"
                    />
                  </div>
                </div>


                <div className="form-group">
                  <label>Discount $</label>
                  <input
                    type="text"
                    value={discount}
                    onChange={(e) => {
                      const raw = Number(e.target.value) || 0;
                      const np = Number(netPrice) || 0;
                      const clamped = Math.max(0, Math.min(raw, np));
                      setDiscount(Number(clamped.toFixed(2)));
                      setTotalPrice(Number((np - clamped).toFixed(2)));
                    }}
                    placeholder="Discount"
                  />
                </div>

              </div>




              <div className="quote_comment">
                <div className="form-group">
                  <label>Comments</label>
                  <textarea
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Comments"
                  />
                </div>
                <button
                  type="button"
                  onClick={handlePendingAcceptance}
                  className="btn"
                  disabled={isAccepted}
                >
                  {isAccepted ? "Quote Accepted" : "Pending Acceptance"}
                </button>
              </div>

              <div className="new_quote_btns">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn"
                >
                  Save
                </button>
                <button type="button" className="btn" onClick={() => handleGeneratePdf(customer)}>
                  Generate PDF
                </button>
                <button
                  onClick={() => handleEmail(customer)}
                  type="button"
                  className="btn"
                  disabled={isEmailLoading}
                >
                  {isEmailLoading ? (
                    <>
                      <ClipLoader color="#fff" size={18} /> Sending...
                    </>
                  ) : (
                    "Email Quote"
                  )}
                </button>

                <button
                  type="button"
                  onClick={handleCreateOrder}
                  className="btn"
                >
                  Create Order
                </button>
              </div>
            </form>
          </div>

          <AddProductModal
            isModalOpen={isModalOpen}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            handleSaveProductdata={handleSaveProductdata}
            handleModalClose={handleModalClose}
            productOptions={productOptions}
            customer_id={customer_id}
            quoteNo={quoteNo}
            setIsQuoteCreated={setIsQuoteCreated}
            isQuoteCreated={isQuoteCreated}
            onQuoteCreated={handleQuoteCreated}
            addOrderForSuit={false}
          />
        </div>
      </Layout>
    </>
  );
};

export default NewQuote;
